import axiosInstance from "../../../../api/axiosInstance";
import { endpoints } from "../../../../services/endpoints";
import { getSupportRequest, getSupportRequestError, getSupportRequestSuccess } from "../../../slices/teams/members/GetSupportSlice";

export const GetSupportApi = (currentPage,limit,searchTerm,status) => async (dispatch) => {
    const queryParams = new URLSearchParams({ currentPage: currentPage, limit: limit,searchTerm:searchTerm,status:status }).toString();

    const url = `${endpoints.SupportList}?${queryParams}`;
    try {
        dispatch(getSupportRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getSupportRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getSupportRequestError(_error));
            });
    } catch (error) { }
};
